import { parse } from 'zrender/lib/tool/color';

export type BlendName = 'multiply';
export type BlendHandler = (a: number, b: number) => number;
export type ColorVector = number[];
const MAX_COLOR_VALUE = 255;
const COLOR_PARSER = parse;

const blendMethods: {
  [k in BlendName]: BlendHandler;
} = {
  multiply: (a, b) => (a * b) / MAX_COLOR_VALUE
};

export default class Palette {
  static readonly methods = blendMethods;

  colorList: string[];

  constructor(colors: string[]) {
    this.colorList = colors;
  }

  getColor(index: number): string {
    if (index < 0 || index >= this.colorList.length) {
      throw new Error('Color index out of range');
    }

    return this.colorList[index];
  }

  // 重载签名
  parseColor(index: number): ColorVector;
  parseColor(color: string): ColorVector;
  // 实现签名
  parseColor(colorOrIndex: string | number): ColorVector {
    let colorStr: string;
    if (typeof colorOrIndex === 'number') {
      if (colorOrIndex < 0 || colorOrIndex >= this.colorList.length) {
        throw new Error('Color index out of range');
      }
      colorStr = this.colorList[colorOrIndex];
    } else {
      colorStr = colorOrIndex;
    }

    return COLOR_PARSER(colorStr);
  }

  blendColor(color1: string, color2: string, methodName: BlendName): string {
    const color1Arr = this.parseColor(color1);
    const color2Arr = this.parseColor(color2);

    let val = '';
    for (let i = 0; i < 3; i++) {
      val += `${Palette.methods[methodName](color1Arr[i], color2Arr[i])}, `;
    }

    return `rgba(${val}1)`;
  }

  blendColorArr(indices: number[], methodName: BlendName) {
    const colorArr = indices.map(item => this.getColor(item));

    return colorArr.reduce((prev, curr) => {
      return this.blendColor(prev, curr, methodName);
    });
  }
}
